var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ve-page',{staticClass:"page--role-home-base",attrs:{"full":true,"direct":"vertical","can-back":true,"customeRoadMap":_vm.customeRoadMap}},[_c('div',{staticClass:"content",staticStyle:{"overflow":"auto"}},[_c('router-view',{key:_vm.$route.path})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }